import "./PageSignup.scss";
import "./PageSignupMobile.scss";
import threeheades from "../Assets/Design/top3AnimeHead.png";
import lkiLogo from "../Assets/Design/LKI-logo-straight.png";
import infoIcon from "../Assets/Icons/info-Icons.png";
import circleArrow from "../Assets/Icons/Circle-arrow.png";
import React, { useState, useEffect, useMemo } from "react";
import { validateSignup } from "./SignupHandler";
import passwordValidator from "./SignupPasswordValidator";
import { useNavigate } from "react-router-dom";

import FormInput from "./FormInput/FormInput";
import BirthdatePicker from "./BirthdatePicker/BirthdatePicker";

import PasswordInput from "./PasswordInput/PasswordInput";
import ConfirmPasswordInput from "./PasswordInput/ConfirmPasswordInput";
import Footer from "../Footer/Footer";
import Modal from "../PageLogin/LPContent/Modal/Modal";
import SendOTP from "./Modal/SendOTP";
import { useAppContext } from "../Components/AppProvider";
import { useMediaQuery } from "react-responsive";

function PageSignup() {
  const { setHasBagCount } = useAppContext();

  const [isModalOpen, setModalOpen] = useState(false);
  const [pendingUser, setPendingUser] = useState(null);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const isMobile = useMediaQuery({ maxWidth: 600 });

  const handleSharinganClick = () => {
    setShowPassword((prev) => !prev);
  };
  const handleSharinganClickconfirm = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  const [serverError, setServerError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const validation = passwordValidator(password);
  const allValid = Object.values(validation).every(Boolean);
  const passwordsMatch =
    password && confirmPassword && password === confirmPassword;

  const handleSubmit = async () => {
    const validationErrors = validateSignup({
      firstName,
      lastName,
      birthdate,
      email,
      contact,
      password,
      confirmPassword,
      termsAccepted,
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName,
            lastName,
            birthdate,
            email,
            contact,
            password,
            confirmPassword,
            termsAccepted,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setErrors({});
        setServerError(data.error || "Signup failed. Please try again.");
        setErrors((prev) => ({ ...prev, email: data.error })); // Optional: link error to email field
        alert(data.error);
        return;
      }

      setErrors({});
      setModalOpen(true);
      //alert("✅ Signup successful!");
      //navigate("/login"); // ✅ Redirect to login page
      // Optionally reset the form or redirect
    } catch (error) {
      console.error("Signup error:", error);
      setErrors({ server: "Network error. Try again later." });
    }
  };

  useEffect(() => {
    const checkVerification = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/auth/check-verification?email=${email}`
        );
        const data = await res.json();

        if (data.verified) {
          clearInterval(interval);
          setModalOpen(false);

          // ✅ Show alert first
          alert("✅ Signup successful!");

          // ⏳ Add delay (e.g. 2 seconds) before navigating
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
      } catch (err) {
        console.error(err);
      }
    };

    const interval = setInterval(checkVerification, 4000);
    return () => clearInterval(interval);
  }, [isModalOpen]);
  const maxDate = useMemo(() => {
    const today = new Date();
    const year = today.getFullYear() - 15; // 15 years ago
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // strictly "YYYY-MM-DD"
  }, []); // runs once per mount
  return (
    <>
      <div className="sp-container">
        <div className="sp-form-container">
          <div className="sp-form-Personal">
            {" "}
            {isMobile && (
              <div className="sp-form-footer">
                <img src={threeheades} class="sp-threeheades" />
                <img src={lkiLogo} className="sp-lkiLogo" />
              </div>
            )}
            <div></div>
            <div className="sp-form-header">CREATE YOUR ACCOUNT</div>
            <div className="sp-form-personal-info">
              <div className="sp-form-peronal-header">
                <p>Personal Information</p>
                <hr />
              </div>

              {/* First Name */}
              <FormInput
                id="firstName"
                label="FIRST NAME"
                value={firstName}
                onChange={setFirstName}
                autoComplete="given-name"
                error={errors.firstName}
              />
              {/* Last Name */}
              <FormInput
                id="lastName"
                label="LAST NAME"
                value={lastName}
                onChange={setLastName}
                autoComplete="family-name"
                error={errors.lastName}
              />
              <FormInput
                id="lastName"
                label="BIRTH DATE"
                type="date"
                value={birthdate}
                onChange={setBirthdate}
                max={maxDate} // user must be born on or before this date
                autoComplete="family-name"
                error={errors.birthdate}
              />
              {/* Email */}
              <FormInput
                id="email"
                label="EMAIL ADDRESS"
                type="email"
                value={email}
                onChange={setEmail}
                autoComplete="email"
                error={errors.email || serverError}
              />

              {/* Contact Number - digits only */}
              <FormInput
                id="contact"
                label="CONTACT NUMBER"
                type="text"
                value={contact}
                onChange={setContact}
                autoComplete="tel"
                filterDigitsOnly={true}
                error={errors.contact}
              />
            </div>
            {!isMobile && (
              <div className="sp-form-footer">
                <img src={threeheades} class="sp-threeheades" />
                <img src={lkiLogo} className="sp-lkiLogo" />
              </div>
            )}
          </div>
          <div className="sp-form-Password">
            <div className="sp-form-header">
              <div className="sp-form-header-blank"></div>
            </div>
            <div className="sp-form-password-header">
              <p>Password Requirement</p>
              <hr />
            </div>
            <PasswordInput
              password={password}
              setPassword={setPassword}
              showPassword={showPassword}
              handleSharinganClick={handleSharinganClick}
              allValid={allValid}
              validation={validation}
              errors={errors}
            />
            <ConfirmPasswordInput
              confirmPassword={confirmPassword}
              setConfirmPassword={setConfirmPassword}
              showConfirmPassword={showConfirmPassword}
              handleSharinganClickconfirm={handleSharinganClickconfirm}
              errors={errors}
              passwordsMatch={passwordsMatch}
            />

            <div className="sp-termsconditions">
              <input
                type="checkbox"
                id="terms"
                name="terms"
                value={termsAccepted}
                className="sp-terms-checkbox"
                onChange={(e) => setTermsAccepted(e.target.checked)}
                required
              />
              <label htmlFor="terms" className="sp-terms-label">
                I agree to the <a>Terms and Conditions</a> and{" "}
                <a>Privacy Policy</a>
              </label>
            </div>
            <div className="sp-validation-error-pass">
              {errors.terms && <span>{errors.terms}</span>}
            </div>

            <div className="sp-guide">
              <img src={infoIcon} />
              <p>
                After you press Sign Up, a verification link will be sent to
                your email address. Please click the link to complete your
                registration.
              </p>
            </div>
            <div className="sp-signup-button-wrapper">
              <div className="sp-signup-button" onClick={handleSubmit}>
                <img src={circleArrow} />
                <div className="sp-gradient default"></div>
                <div className="sp-gradient hover"></div>
                <p className="sp-text">SIGN UP</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isMobile && <Footer />}
      <Modal isModalOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        <SendOTP
          email={email}
          onSuccess={(data) => {
            //console.log("✅ Logged in user:", data.user);
            navigate("/customer-profile");
            setHasBagCount(true);
          }}
          onClose={() => setModalOpen(false)}
        />
      </Modal>
    </>
  );
}

export default PageSignup;
